let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("dBUZ0")), load("ig5WW")]).then(() => parcelRequire('kR6P1'));